import React from "react";

const AppFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            className="w-100 py-3 d-flex align-items-center justify-content-between gap-3 p-3 mt-auto"
            style={{ background: '#f8fafc', borderTop: '1px solid #e0e0e0' }}
        >
            <div>
                <a href="https://infinitysoft.com.br/" target="_blank" rel="noopener noreferrer" style={{ color: '#696969' }}>
                    <strong>Infinitysoft </strong>
                </a>
                <span className="ms-1">&copy; {currentYear}.</span>
            </div>
            <div>
                <span className="me-1">By</span>
                <a href="https://bassena.com.br/" target="_blank" rel="noopener noreferrer" className='text-decoration-none' style={{ color: '#696969' }}>
                    <strong >Bassena Dev</strong>
                </a>
            </div>
        </footer>
    );
};

export default React.memo(AppFooter);
